<template>
  <div
    v-for="product in subscriptions"
    :key="product.id"
    class="group mb-4 flex flex-col justify-between rounded-lg border border-border bg-white"
  >
    <div class="flex flex-col justify-start">
      <div class="p-5">
        <div class="flex justify-between">
          <div>
            <p class="mb-1 flex items-center text-base font-semibold text-foreground">
              {{ $t(`pages.settings.accountPage.payments.${product.slug}.title`) }} ·
              <span
                v-if="product.distributions.length > 1"
                class="cursor-pointer pl-1 text-xs text-muted-foreground hover:text-primary/80 hover:underline"
                @click="isModalOpen = true"
                >{{ product.distributions.length }} {{ $t(`pages.settings.subscriptionPage.stores`) }}
                <BaseModal
                  :is-open="isModalOpen"
                  size="3xl"
                  :link-text="$t('global.words.close')"
                  @close="isModalOpen = false"
                  @click="isModalOpen = false"
                >
                  <h4 class="mb-6 text-lg font-semibold text-foreground">
                    {{ $t(`pages.settings.subscriptionPage.storesInvolved`) }}
                    {{ $t(`pages.settings.accountPage.payments.${product.slug}.title`) }}
                  </h4>
                  <span
                    v-for="distribution in product.distributions"
                    :key="distribution.id"
                    class="mx-2 rounded-md bg-primary/10 px-2 py-1.5 text-xs font-semibold leading-5 text-primary"
                  >
                    {{ distribution.store_company_product.store.name }}
                  </span>
                </BaseModal>
              </span>
              <span v-else class="pl-1 text-xs text-muted-foreground"
                >{{ product.distributions[0].store_company_product.store.name }}
              </span>
            </p>
            <p class="mb-2 line-clamp-4 text-sm text-foreground">
              <span v-if="product.isSubscription"
                >{{ $t(`pages.settings.subscriptionPage.startsIn`) }} {{ product.startedAtFormatted }}</span
              >
              <span v-else
                >{{ $t(`pages.settings.subscriptionPage.willBeBilledAt`) }} {{ product.startedAtFormatted }}</span
              >
              <span v-if="product.smsPackQuantity">
                ·
                <span class="font-medium"
                  >{{ product.smsPackQuantity }} {{ $t(`pages.settings.subscriptionPage.includedSms`) }}</span
                ></span
              >
            </p>
          </div>
          <div class="mb-4 flex flex-row items-center space-x-2">
            <p class="rounded-md bg-primary/10 px-2 py-1.5 text-xs font-semibold leading-5 text-primary">
              <span v-if="!product.isTrial">
                <span :class="[hasDiscount(product) ? 'line-through' : '']">
                  <span v-if="product.distributions.length > 1" class="text-xs font-medium">
                    {{ product.distributions.length }} x
                  </span>
                  {{ product.totalPriceWithoutVat / 100 }}€ {{ $t(`pages.settings.subscriptionPage.taxExcluded`) }}
                  <span v-if="product.isSubscription">{{ $t(`pages.settings.subscriptionPage.monthly`) }}</span>
                </span>
                <BaseChip
                  v-if="hasDiscount(product)"
                  class="ml-2"
                  color="green"
                  :text="
                    [
                      `${product.discountedPriceWithoutVat / 100}€`,
                      $t(`pages.settings.subscriptionPage.taxExcluded`),
                      product.isSubscription ? $t(`pages.settings.subscriptionPage.monthly`) : ''
                    ]
                      .filter(Boolean)
                      .join(' ')
                  "
                />
              </span>
              <span v-else> {{ $t(`pages.settings.subscriptionPage.currentlyInTrial`) }} </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseModal } from '@/ui/dialog'
export default {
  components: {
    BaseModal
  },
  props: {
    subscriptions: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      subscription: null,
      isModalOpen: false
    }
  },
  methods: {
    hasDiscount(product) {
      if (product.discountedPriceWithoutVat === null) {
        return false
      }
      return product.discountedPriceWithoutVat < product.totalPriceWithoutVat
    }
  }
}
</script>
